export default [
  '$uibModalInstance',
  'config',
  'onApprove',
  'dealRentService',
  function (
    $uibModalInstance,
    config,
    onApprove,
    dealRentService,
  ) {
  this.ofertaUrl = config.get('dealV2.ofertaUrl');
  this.rulesApproved = false;
  this.hasError = false;

  const homeownerSubscriptionPaymentEnabled = config.get(
    'homeownerSubscriptionPayment.enabled',
  );
  this.paymentText = homeownerSubscriptionPaymentEnabled
    ? '1 990 ₽ в месяц, ничего не спишем, пока не заключён договор. Никакой комиссии с арендаторов.'
    : 'Для вас это бесплатно, а с арендатора мы возьмем комиссию 15% и подписку 990 ₽ в месяц';


  this.images = {
    phone: require('./assets/phone.png'),
    detective: require('./assets/detective.png'),
    heart: require('./assets/heart.png'),
    home: require('./assets/home.png'),
    card: require('./assets/card.png'),
  };

  this.onApprove = () => {
    dealRentService.addDealVersion();
    onApprove();
    $uibModalInstance.dismiss();
  };
}];
